import { Toaster } from '@lovable/components/ui/toaster'
import { Toaster as Sonner } from '@lovable/components/ui/sonner'
import { TooltipProvider } from '@lovable/components/ui/tooltip'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { CreditProvider } from '@lovable/contexts/CreditContext'
import { Layout } from '@lovable/components/Layout'

const queryClient = new QueryClient()

export function LovableRoot({ children }: { children: React.ReactNode }) {
  return (
    <div className='LOVABLE_ROOT'>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <CreditProvider>
            <Layout>{children}</Layout>
          </CreditProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </div>
  )
}
